import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María G.',
    text: 'Mi hijo dejó la tablet en 3 días. Ahora pide sus actividades del megapack cada mañana. ¡Increíble!',
    stars: 5,
    color: 'bg-pink-100',
    avatarColor: 'bg-pink-300'
  }, {
    name: 'Carlos R.',
    text: 'Como padre primerizo no sabía cómo entretener a mi hija sin pantallas. Este pack me salvó la vida.',
    stars: 5,
    color: 'bg-blue-100',
    avatarColor: 'bg-blue-300'
  }, {
    name: 'Ana L.',
    text: 'Soy maestra y lo uso en mi salón. Los niños están fascinados con las actividades. Lo recomiendo al 100%.',
    stars: 5,
    color: 'bg-green-100',
    avatarColor: 'bg-green-300'
  }, {
    name: 'Roberto M.',
    text: 'Compramos el pack para toda la familia. Mis 3 hijos lo disfrutan cada día. La mejor inversión.',
    stars: 5,
    color: 'bg-yellow-100',
    avatarColor: 'bg-yellow-300'
  }, {
    name: 'Laura P.',
    text: 'Mi pequeña de 2 años ama colorear las páginas. Ya no pide el celular. ¡Gracias!',
    stars: 5,
    color: 'bg-purple-100',
    avatarColor: 'bg-purple-300'
  }];
  return <section className="bg-doodles py-20 px-4" data-id="element-316">
      <div className="max-w-6xl mx-auto" data-id="element-317">
        <h2 className="text-3xl md:text-5xl font-black text-center text-gray-900 mb-16" data-id="element-318">
          Historias de familias <span className="text-green-600" data-id="element-319">felices</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-320">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-3xl shadow-lg border-b-8 border-gray-100 relative transform transition-transform hover:-translate-y-2" data-id="element-321">
              <Quote className="absolute top-4 right-4 w-10 h-10 text-gray-100" data-id="element-322" />

              <div className="flex items-center gap-4 mb-6" data-id="element-323">
                {/* CSS Avatar */}
                <div className={`w-14 h-14 rounded-full ${t.avatarColor} flex items-center justify-center border-4 border-white shadow-sm overflow-hidden`} data-id="element-324">
                  <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10 text-white opacity-90 translate-y-2" data-id="element-325">
                    <circle cx="12" cy="8" r="4" fill="currentColor" data-id="element-326" />
                    <path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" fill="currentColor" data-id="element-327" />
                  </svg>
                </div>
                <div data-id="element-328">
                  <p className="font-bold text-gray-900 text-lg" data-id="element-329">{t.name}</p>
                  <div className="flex gap-1" data-id="element-330">
                    {[...Array(t.stars)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-331" />)}
                  </div>
                </div>
              </div>

              <p className="text-gray-600 italic leading-relaxed" data-id="element-332">"{t.text}"</p>
            </div>)}
        </div>
      </div>
    </section>;
}